import React from "react";
import {
  Box,
  Container,
  Heading,
  Text,
  VStack,
  Link,
  Button,
  useColorModeValue,
  Select,
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const AccountDeletionPage = () => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();

  const headingColor = useColorModeValue("gray.800", "white");
  const textColor = useColorModeValue("gray.600", "gray.300");
  const linkColor = useColorModeValue("blue.500", "blue.300");

  return (
    <Box bg={useColorModeValue("gray.50", "gray.900")} minH="100vh" py={10}>
      {/* Language Switcher */}
      <Box position="fixed" top="4" right="4" zIndex="120" p={2}>
        <Select
          value={i18n.language}
          onChange={(e) => i18n.changeLanguage(e.target.value)}
          width="120px"
          bg="white"
          color="black"
          size="sm"
        >
          <option value="en">English</option>
          <option value="fr">Français</option>
          <option value="es">Español</option>
        </Select>
      </Box>

      <Container
        maxW="container.md"
        bg={useColorModeValue("white", "gray.800")}
        p={8}
        borderRadius="lg"
        boxShadow="xl"
      >
        <VStack spacing={6} align="stretch">
          <Heading size="2xl" color={headingColor} textAlign="center">
            Delete Your PeerX Account
          </Heading>

          <Text color={textColor}>
            At PeerX, we value your privacy and autonomy. If you wish to delete your account, you may do so at any time via the app or by contacting our support team.
          </Text>

          <Heading size="lg" color={headingColor}>
            How to Request Deletion
          </Heading>
          <Text color={textColor}>
            Option 1: Log into the app, go to <strong>Settings → Close Account</strong>, and follow the steps.
          </Text>
          <Text color={textColor}>
            Option 2: Email us at{" "}
            <Link href="mailto:privacy.legal@peerx.ca" color={linkColor}>
              privacy@peerx.ca
            </Link>{" "}
            from the email linked to your account, requesting account and data deletion.
          </Text>

          <Heading size="lg" color={headingColor}>
            What Happens When You Delete Your Account?
          </Heading>
          <Text color={textColor}>
            - Your PeerX profile and personal information are permanently deleted.
          </Text>
          <Text color={textColor}>
            - All listings you created are cancelled and hidden.
          </Text>
          <Text color={textColor}>
            - Chat history and transaction records are removed from the app (except anonymized system logs if required by law).
          </Text>

          <Heading size="lg" color={headingColor}>
            Retained Data
          </Heading>
          <Text color={textColor}>
            Certain financial and audit records may be retained for up to 90 days, as required by regulatory or fraud prevention policies.
          </Text>

          <Heading size="lg" color={headingColor}>
            Need Help?
          </Heading>
          <Text color={textColor}>
            Contact us at{" "}
            <Link href="mailto:customer.support@peerx.ca" color={linkColor}>
              support@peerx.ca
            </Link>{" "}
            for assistance.
          </Text>

          <Button colorScheme="blue" variant="solid" onClick={() => navigate("/")}>
            Back to Home
          </Button>
        </VStack>
      </Container>
    </Box>
  );
};

export default AccountDeletionPage;
